import { useParams } from 'react-router';
import { isArrangementType } from '@pams/shared';
import { ArrangementsList } from '@/pages/Arrangements';
import NotFoundPage from '@/pages/NotFound';

/**
 * ─────────────────────────────────────────────────────────────────────────────────────
 *  [P7B.1 §4] A TYPED ARRANGEMENT'S OWN LIST — `/pa/:typeKey`, the sidebar's "Durga Puja PA".
 *
 *  ⚠️ IT IS MANAGE ARRANGEMENTS' LIST, NOT A SECOND ONE. `ArrangementsList` with `fixedType` sends
 *  P7B's typed request — `type`, and the any-date window while no bound is set — and renders that
 *  tab's columns, empty states and template actions, unchanged. One list component, one `queryFn`.
 *
 *  ⚠️ KEYED ON THE TYPE, so moving from one type's list to another's remounts it rather than
 *  carrying one list's selection, discard mode or grouping into the other.
 *
 *  ⚠️ AN UNREGISTERED KEY IS NOT FOUND — never the untyped list, which would show a page titled for
 *  nothing and holding every ordinary order. Access is the route's `arrangement.read`, exactly
 *  `/arrangements`' own, and FR-3.6 is the server's, on every row.
 * ─────────────────────────────────────────────────────────────────────────────────────
 */
const TypedArrangementsPage = (): React.ReactElement => {
  const { typeKey } = useParams();
  if (!isArrangementType(typeKey)) return <NotFoundPage />;
  return <ArrangementsList key={typeKey} fixedType={typeKey} />;
};

export default TypedArrangementsPage;
